import lodash from "lodash";
import axios from "axios";
import datepicker from "jquery-datetimepicker";
import 'vue-search-select/dist/VueSearchSelect.css';

// Import jQuery with a different variable name
import jQueryModule from 'jquery';

// Assign jQuery to window but don't overwrite existing jQuery
if (!window.jQuery) {
    window.$ = window.jQuery = jQueryModule;
} else {
    // If jQuery is already defined, use it
    window.$ = window.jQuery;
}

// Then import other dependencies
import Popper from 'popper.js';
import 'bootstrap';

// Import CSS files
import '/public/fileuploader/css/jquery.fileuploader.min.css';
import '/public/fileuploader/css/jquery.fileuploader-theme-dragdrop.css';
import '/public/fileuploader/font/font-fileuploader.css';

window._ = lodash;
window.axios = axios;
window.datepicker = datepicker;
window.Popper = Popper;

let Apitoken = document.head.querySelector('meta[name="api-token"]');

if (Apitoken) {
    window.axios.defaults.headers.common["Authorization"] =
        "Bearer " + Apitoken.content;
}

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}
jQueryModule.datetimepicker.setLocale("sk");
